import { render, staticRenderFns } from "./NestedColumns.vue?vue&type=template&id=a2bf47ba&"
import script from "./NestedColumns.vue?vue&type=script&lang=js&"
export * from "./NestedColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports